/**
 * Bug #438
 * @Author Anupama P
 * @Date 23 June 2021
 */
import { Select } from "antd";
import { wordCapitalize } from "config/constants";

const { Option } = Select;

const Sex = [
  { value: "m", label: "Male", id: 1 },
  { value: "f", label: "Female", id: 2 },
  { value: "u", label: "Unknown", id: 3 },
];

/**Bug #610: Show Profile info when scan qrcode @Author Jithin Kuriakose @Date 21 Oct 2021*/
const getGenderUsingKey = (key) => {
  const gender = Sex.filter((item) => (item.value === key))
  return gender[0]?.label;
} 
/*End Bug #610*/
/**
* Bug #489
* @Author Anupama P
* @Date 9 Jul 2021
*/
const Prices = [
  { value: "f", label: "free", id: 1 },
  { value: "c", label: "Custom Price (per hour)", id: 2 },
];
/** End */

const Race = [
  { value: "1002-5", label: "American Indian or Alaska Native", id: 1 },
  { value: "2028-9", label: "Asian", id: 2 },
  { value: "2054-5", label: "Black Or African American", id: 3 },
  {
    value: "2076-8",
    label: "Native Hawaiian or Other Pacific Islander",
    id: 4,
  },
  { value: "2131-1", label: "Other Race", id: 5 },
  { value: "2106-3", label: "White", id: 6 },
];

const Ethnicity = [
  { value: "2135-2", label: "Hispanic or Latino", id: 1 },
  { value: "2186-5", label: "Not Hispanic or Latino", id: 2 },
  { value: "U", label: "Unknown", id: 3 },
];
const AccountType = [
  { value: "INSURANCE", label: "INSURANCE", id: 1 },
  { value: "SELF PAY", label: "SELF PAY", id: 2 },
  { value: "OTHER", label: "OTHER", id: 3 },
];
const generateGender = () => optionTemplate(Sex);
const generateAccountType = () => optionTemplate(AccountType);

let optionTemplate = (values) =>
  values.map((value, index) => (
    <Option value={value.value} id={value.id} key={index}>
      {value.label}
    </Option>
  ));
/**
* Bug #438
* @Author Anupama P
* @Date 05 Jul 2021
*/
const getAllCountries = () => new Promise<any>((resolve, reject) => {
  import('components').then(({ Country }) => {
    // Country.getAllCountries().map((country) =>
    //   values.push({
    //     value: country.name,
    //     label: country.name,
    //     isocode: country.isoCode,
    //   })
    // );
    resolve(optionCountryTemplate(Country.getAllCountries()));
  }).catch((err) => {
    reject(err);
  });
});

const getAllCountriesCodes = () => new Promise<any>((resolve, reject) => {
  import('components').then(({ Country }) => {
    // Country.getAllCountries().map((country) =>
    //   values.push({
    //     value: country.name,
    //     label: country.name,
    //     isocode: country.isoCode,
    //   })
    // );
    resolve(optionCountryCodeTemplate(Country.getAllCountries(), true));
  }).catch((err) => {
    reject(err);
  });
});
const getStatesOfCountry = (country, needIsoCode = false) => new Promise<any>((resolve, reject) => {
  import('components').then(({ State }) => {
    // State.getStatesOfCountry(country).map((country, index) =>
    //   values.push({
    //     value: country.name,
    //     label: country.name,
    //     isocode: country.isoCode,
    //     key: index,
    //   })
    // );
    resolve(optionCountryTemplate(State.getStatesOfCountry(country), needIsoCode));/** Bug #611 @Author Linda Susan Raju @Date 11 Oct 2021 */

  }).catch((err) => {
    reject(err);
  });
});

let optionCountryTemplate = (values, needIsoCode = false) =>
  values.map((value, index) => (/** Bug #611 @Author Linda Susan Raju @Date 11 Oct 2021 */
    <Option value={needIsoCode ? value.isoCode : value.name} id={index} key={value.isoCode}>
      {value.name}
    </Option>
  ));
let optionCountryCodeTemplate = (values, needIsoCode = false) =>
  values.map((value, index) => (/** Bug #611 @Author Linda Susan Raju @Date 11 Oct 2021 */
    value.phonecode && <option selected={value.phonecode == "1"} value={needIsoCode ? "+"+value.phonecode : value.name} id={index} key={index}>
      {"+"+value.phonecode}
    </option>
  ));
/** End */
/**
  * Bug #503
  * @Author Jithin Kuriakose
  * @Date 19 July 2021
  */
/**
  * Bug #503
  * @Author Anupama P
  * @Date 06 Sep 2021
  */
const InsuranceRelationship = [
  { value: "1", label: "Spouse", id: 1 },
  { value: "4", label: "Grandfather or Grandmother", id: 2 },
  { value: "5", label: "Grandson or Grandaughter", id: 3 },
  { value: "7", label: "Nephew or Niece", id: 1 },
  { value: "10", label: "Foster Child", id: 2 },
  { value: "15", label: "Ward of the Court", id: 3 },
  { value: "17", label: "Stepson or Stepdaughter", id: 1 },
  { value: "18", label: "Self", id: 2 },
  { value: "19", label: "Child", id: 3 },
  { value: "20", label: "Employee", id: 1 },
  { value: "21", label: "Unknown", id: 2 },
  { value: "22", label: "Handicapped/Dependent", id: 3 },
  { value: "23", label: "Sponsored Dependent", id: 1 },
  { value: "24", label: "Dependent of Minor Dependent", id: 2 },
  { value: "29", label: "Significant Other", id: 3 },
  { value: "32", label: "Mother", id: 1 },
  { value: "33", label: "Father", id: 2 },
  { value: "36", label: "Emancipated Minor", id: 3 },
  { value: "39", label: "Organ Donor", id: 1 },
  { value: "40", label: "Cadaver Donor", id: 2 },
  { value: "41", label: "Injured Plaintiff", id: 3 },
  { value: "43", label: "Child Where Insured Has No Financial Responsibility", id: 1 },
  { value: "53", label: "Life Partner", id: 2 },
  { value: "G8", label: "Other Relationship", id: 3 },
];
/**End Bug#503 */
const generateInsuranceRelationship = () => optionTemplate(InsuranceRelationship);

const InsuranceCoverage = [
  { value: "P", label: "Primary", id: 1 },
  { value: "S", label: "Secondary", id: 2 },
  { value: "T", label: "Tertiary", id: 3 },
];
const generateInsuranceCoverage = () => optionTemplate(InsuranceCoverage);

/**
  * Bug #503
  * @Author Anupama P
  * @Date 06 Sep 2021
  */
const renderCovergeData = (optionVal) => {
  return wordCapitalize(InsuranceCoverage.filter((ins) => ins.value === optionVal)[0]?.label) //Bug# 512* @Author Akhil MC * @Date 26 July 2021
}

const renderRelationShipData = (optionVal) => {
  return wordCapitalize(InsuranceRelationship.filter((ins) => ins.value === optionVal)[0]?.label) //Bug# 512* @Author Akhil MC * @Date 26 July 2021
}
/**End Bug #503**/

/**Bug #698  @Author Linda Susan Raju @Date 30 Dec 2021*/
const DocumentTypeSelectList = [
  { value: "ID", label: "ID", id: 1 },
  { value: "LAB", label: "LAB", id: 2 },
  { value: "INSURANCE_CARD", label: "INSURANCE CARD", id: 3 },
  { value: "DRIVING_LICENCE", label: "DRIVING LICENCE", id: 4 },
  { value: "OTHER", label: "OTHER", id: 5 },
  { value: "PAST_MR", label: "PAST MR", id: 6 },
  { value: "RADIOLOGY", label: "RADIOLOGY", id: 7 },
  { value: "RX", label: "RX", id: 8 },
  { value: "SIGNED_FORMS", label: "SIGNED FORMS", id: 9 },
  { value: "IMAGE_RESULTS", label: "IMAGE RESULTS", id: 10 },
  { value: "TELEMED", label: "TELEMED", id: 11 },
  { value: "eFAX", label: "eFAX", id: 12 },
];

const generateDocumentTypeList = () => optionTemplate(DocumentTypeSelectList);
/**End Bug#698 */

export {
  optionTemplate,
  generateGender,
  Race,
  Ethnicity,
  generateAccountType,
  getStatesOfCountry,
  getAllCountries,
  Prices,
  generateInsuranceRelationship,/* Bug #503 @Author Jithin Kuriakose @Date 19 July 2021 */
  generateInsuranceCoverage,/* Bug #503 @Author Jithin Kuriakose @Date 19 July 2021 */
  InsuranceCoverage, /*Bug #503 @Author Akhil MC @Date 26 July 2021 */
  renderCovergeData,
  renderRelationShipData,
  getGenderUsingKey, /**Bug #610: Show Profile info when scan qrcode @Author Jithin Kuriakose @Date 21 Oct 2021*/
  generateDocumentTypeList,
  getAllCountriesCodes,
};
 /** End */